import { createContext, ReactNode } from 'react';
import {
  DataRoomRFI,
  DataRoomRFIStatusCounts,
  DataRoomRfiTemplate,
} from '../../models/DataRoomRfi';
import utils from 'utils';

export const RFI_LIST_STATUS_FILTER_ALL = 'all';

type RfiContextProps = {
  isLoadingTemplates: boolean;
  rfiTemplates: DataRoomRfiTemplate[];
  isRfiListLoading: boolean;
  rfiListItems: DataRoomRFI[];
  rfiListTotalPages: number;
  rfiListTotalItems: number;
  rfiListStatusFilter: string;
  rfiListSearchInputValue: string;
  rfiListStatusCounts: DataRoomRFIStatusCounts;
  rfiListStatusCountsFilter: string;
  isEmpty: boolean;
  onRfiListStatusFilterChange: (value: string) => void;
  onRfiListSearchInputChange: (value: string) => void;
  updateRfiListItem: (updatedRfi: Partial<DataRoomRFI>) => void;
  refetch: () => void;
  refetchRfiStatusCounts: () => void;
  refetchTemplates: () => void;
  getRfiTemplateById: (templateId: string) => DataRoomRfiTemplate;
  deleteTemplate: (_id: string) => void;
  openSaveAsTemplateModal: (rfi: DataRoomRFI) => void;
  showActionUndo: (
    content: ReactNode,
    onUndo: () => void,
    onExpire?: () => void,
  ) => void;
};

export default createContext<Partial<RfiContextProps>>({
  isLoadingTemplates: false,
  rfiTemplates: [],
  isRfiListLoading: false,
  rfiListItems: [],
  rfiListTotalPages: 0,
  rfiListTotalItems: 0,
  rfiListStatusFilter: RFI_LIST_STATUS_FILTER_ALL,
  rfiListSearchInputValue: '',
  rfiListStatusCounts: null,
  rfiListStatusCountsFilter: RFI_LIST_STATUS_FILTER_ALL,
  isEmpty: false,
  onRfiListStatusFilterChange: utils.noop,
  updateRfiListItem: utils.noop,
  onRfiListSearchInputChange: utils.noop,
  refetch: utils.noop,
  refetchRfiStatusCounts: utils.noop,
  refetchTemplates: utils.noop,
  getRfiTemplateById: utils.noop,
  deleteTemplate: utils.noop,
  openSaveAsTemplateModal: utils.noop,
  showActionUndo: utils.noop,
});
